import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const styles = {
  signature: {
    marginTop: 8,
    flexDirection: 'row' as const,
    justifyContent: 'space-between' as const
  },
  signatureBox: {
    width: '45%',
    textAlign: 'center' as const,
    padding: 8
  },
  signatureTitle: {
    fontSize: 9,
    fontWeight: 'bold' as const,
    marginBottom: 10,
    color: '#333'
  },
  signatureSpace: {
    height: 30,
    borderBottom: '1px solid #ccc',
    marginBottom: 5
  }
};

const Signatures: React.FC = () => (
  <View style={styles.signature}>
    <View style={styles.signatureBox}>
      <Text style={styles.signatureTitle}>Người mua hàng (Ký, ghi rõ họ tên)</Text>
      <Text style={styles.signatureTitle}>Buyer (Sign, Fullname)</Text>
      <View style={styles.signatureSpace}></View>
    </View>
    <View style={styles.signatureBox}>
      <Text style={styles.signatureTitle}>Người bán hàng (Ký, ghi rõ họ tên)</Text>
      <Text style={styles.signatureTitle}>Seller (Sign, Fullname)</Text>
      <View style={styles.signatureSpace}></View>
    </View>
  </View>
);

export default Signatures;
